export enum HttpStatusCode {
  unkownError = 0,
  badRequest = 400,
  unAuthorized = 401,
  forbidden = 403,
  notFoaund = 404,
  internalServerError = 500
}
